<template>
  <div>
    <modal v-if="visible">
      <template slot="modal-header">
        <h2 class="mt-3">{{ scopeDisplay }} Availability</h2>
      </template>
      <template slot="modal-body">
        <div class="px-3">
          <vue-good-table :columns="columns" :rows="data"></vue-good-table>
        </div>
      </template>
      <template slot="modal-footer">
        <div class="mb-3">
          <app-primary-button
            label="Close"
            @click.native="closeModal"
          ></app-primary-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table';
import Modal from '../../../helpers/Modal';
import AppPrimaryButton from '../../AppComponents/Forms/AppPrimaryButton.vue';

export default {
  props: ['scopeDisplay', 'data', 'visible'],
  components: {Modal, VueGoodTable, AppPrimaryButton},
  computed: {
    columns() {
      return [
        {
          field: 'name',
          label: 'Name',
        },
      ];
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  }
};
</script>
